import { RefObject, useCallback } from 'react';

import {
  useUnifiedRfqsService,
  useRfqsFetchData,
} from '@paradigm/features/src/unified-rfqs/contexts/unified-rfqs';
import TableBottomLoader from '#/components/tables/TableBottomLoader';
import { toast } from '#/components/UnifiedRfqs/toast';
import { useRfqFiltersValue } from '@paradigm/features/src/unified-rfqs/ui/rfq-filters/filter-provider';
import { useWsStatus } from '@paradigm/features/src/unified-rfqs/contexts/use-ws-status';

interface Props {
  readonly scrollableRef: RefObject<HTMLElement>;
}

export default function RfqsBottomLoader(props: Props) {
  const { scrollableRef } = props;
  const { fetcher } = useUnifiedRfqsService();
  const { canFetchMore, status } = useRfqsFetchData();
  const {
    state: { productCodes, strategyCodes },
  } = useRfqFiltersValue();
  const { subscribing, connected } = useWsStatus();

  const onError = useCallback(({ message }: { message: string }) => {
    toast(message);
  }, []);

  const handleFetchMore = useCallback(() => {
    fetcher.fetchMore({ productCodes, strategyCodes }, onError);
  }, [onError, productCodes, fetcher, strategyCodes]);

  return (
    <TableBottomLoader
      disabled={!canFetchMore}
      isLoading={!connected || subscribing || status !== 'idle'}
      scrollableRef={scrollableRef}
      onFetchMore={handleFetchMore}
    />
  );
}
